import { connect } from 'react-redux'

import { SeatTradeSearchResultsFormName } from '../../config/forms'

import parseFlightId from '../../utils/parseFlightId'
import getLabels from '../../utils/getLabels'

import SeatTradeTradesOverview from '../../components/SeatTradeTradesOverview'

const formFieldsToFilter = [
  'startDate',
  'endDate',
  'departureAirport',
  'arrivalAirport',
  'tourOperator',
]

export const mapStateToProps = state => {
  const {
    form,
    v1seatTrade: { items: seatTradeFlights, seatsAreBeingTraded },
    v1searchQuery: {
      results: { departureAirportId, arrivalAirportId },
    },
    v1airports: { items: airports },
  } = state
  const seatTradeForm = form[SeatTradeSearchResultsFormName] || {}
  const seatTradeFormValues = seatTradeForm.values || {
    tourOperator: { value: { name: '' } },
  }

  const flights = Object.keys(seatTradeFormValues)
    .reduce((collection, value) => {
      if (formFieldsToFilter.includes(value)) return collection
      const { date, ...rest } = parseFlightId(value)

      const seatTradeFlight = seatTradeFlights.find(
        ({ flightId, details: { departureDate = '' } }) => {
          return flightId === value && departureDate === date
        }
      )

      return [
        ...collection,
        {
          ...rest,
          date: seatTradeFlight.details.departureDate,
          time: seatTradeFlight.details.departureTime,
          day: seatTradeFlight.details.departureDay,
          seats: parseInt(seatTradeFormValues[value][value]),
        },
      ]
    }, [])
    .sort((a, b) => {
      return new Date(a.date).getTime() - new Date(b.date).getTime()
    })

  return {
    tourOperator: seatTradeFormValues.tourOperator.value.name,
    flights,
    departureAirportName: (
      airports.find(airport => airport.id === departureAirportId) || {
        name: departureAirportId,
      }
    ).name,
    arrivalAirportName: (
      airports.find(airport => airport.id === arrivalAirportId) || {
        name: arrivalAirportId,
      }
    ).name,
    seatsAreBeingTraded,
    disclaimerText: getLabels('seat_trade_warning_this_cannot_be_undone'),
  }
}

export default connect(mapStateToProps)(SeatTradeTradesOverview)
